import { Link } from 'react-router-dom';

import { Button, Card, Notice } from '@kollez/design-system';

/**
 * /mock-report — Deep-audit rewrite (Page 29/N).
 *
 * The previous version of this page was a direct port of the static
 * Kollez mock design: every score, every question, every feedback
 * bullet, the interview date, the mentor's name were all hardcoded
 * in the component. A student landing here saw a fake report about a
 * fake interview they never took — a straight fabrication under the
 * feedback_fabricated_aggregates memory rule.
 *
 * The real mock report lives on /mock/:id (see MockSession.tsx's
 * MockReportCard). It reads the AssessmentAttempt + Nexie grading
 * back off the API and reports the student's actual scores. This
 * standalone /mock-report route no longer had a use.
 *
 * Rather than delete the route (there may be old bookmarks or emails
 * pointing here), we render an honest signpost that routes the student
 * to the real per-session reports on /mock.
 */
export function StudentMockReportPage() {
  return (
    <div className="stack">
      <div className="page-header">
        <div className="ph-text">
          <p className="eyebrow">Mock reports</p>
          <h1 className="h-page">Open a specific session</h1>
          <p className="subhead">
            Mock reports are per-session — every practice run gets its own graded transcript.
            Pick a session on your Mock page to see your real feedback.
          </p>
        </div>
      </div>

      <Card padding="lg">
        <Notice tone="info">
          There's no combined mock report — Nexie grades each session individually and the report
          lives on the session's own page.
        </Notice>
        <div className="flex gap-2 flex-wrap mt-4">
          <Link to="/mock">
            <Button variant="primary">Open my mock sessions</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
